import Schema from 'AppReact/schema';

export default {
  date: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  month: Schema('string', 'primitive-nullable', { defaultValue: null }),
  day: Schema('string', 'primitive-nullable', { defaultValue: null }),
  year: Schema('string', 'primitive-nullable', { defaultValue: null }),
  dayInputRef: Schema({}, 'object', { defaultValue: null }),
  monthInputRef: Schema({}, 'object', { defaultValue: null }),
  yearInputRef: Schema({}, 'object', { defaultValue: null }),
  disablePastDates: Schema('boolean', 'primitive', { defaultValue: false }),
  invalidDate: Schema('boolean', 'primitive', { defaultValue: false })
}